// src/pages/approval/ExpenseDraftNew.jsx
import React from "react";
import DraftDocumentNew from "../draft_document/DraftDocumentNew";

export default function ExpenseDraftNew() {
  return <DraftDocumentNew fixedDocumentType="expense_draft" />;
}
